import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AuditAnnouncementLog } from '../models/audit/auditAnnoucementlog';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AuditAnnouncementService {
  private http = inject(HttpClient);
  configService = inject(ConfigService);

  // Get Data by id
  getDataById(id: string): Observable<AuditAnnouncementLog[]> {
    return this.http.get<AuditAnnouncementLog[]>(
      this.configService.getConfiguration().apiHost + '/api/audit/announcementlogs/' + id
    );
  }
}
